module.exports = __webpack_public_path__ + "img/lens-150-minus-05.41f01586.png";